'use strict';
/* COMPONENT - C04.05 Related links 1.0 */

import Listing from './uif_listing.js';

class RelatedLinksListing extends Listing {
    constructor (element) {
        super(element);
        this.sixes = this.root.querySelectorAll('.base6 .related-links-item');
        this.pairs = Array.from(this.sixes).reduce((final, six) => {
            if (final.length) {
                if (final[final.length - 1].length < 2) {
                    final[final.length - 1].push(six);
                } else {
                    final[final.length] = [six];
                }
            } else {
                final[0] = [];
                final[0].push(six);
            }
            
            return final;
        }, []);
        
        setTimeout(() => {
            this.sortContentSize();  
        }, 0);
    }
    
    updateWidth() {
        this.windowWidth = document.body.clientWidth;
        this.sortContentSize();
    }
    
    sortContentSize() {
        this.pairs.forEach((pair) => {
            if (pair.length > 1) {
                let oneH3 = pair[0].querySelector('h3, h2'),
                    oneP = pair[0].querySelector('p'),
                    twoH3 = pair[1].querySelector('h3, h2'),
                    twoP = pair[1].querySelector('p'),
                    h3Height,
                    pHeight;
                
                oneH3.style.removeProperty('height');
                twoH3.style.removeProperty('height');
                oneP.style.removeProperty('height');
                twoP.style.removeProperty('height');
                
                h3Height = oneH3.offsetHeight >= twoH3.offsetHeight ? oneH3.offsetHeight : twoH3.offsetHeight,
                pHeight = oneP.offsetHeight >= twoP.offsetHeight ? oneP.offsetHeight : twoP.offsetHeight;
                
                oneH3.style.height = h3Height + 'px';
                twoH3.style.height = h3Height + 'px';
                oneP.style.height = pHeight + 'px';
                twoP.style.height = pHeight + 'px';
            }
        });
    }
}

let relatedLinks = document.querySelectorAll('.related-links'),
    i;

for (i = 0; i < relatedLinks.length; i += 1) {
    new RelatedLinksListing(relatedLinks[i], true);
}
